import { createFileRoute } from "@tanstack/react-router";
import { AccesoForm } from "@/components/operacion-portal/AccesoForm";
import { OperacionPwa } from "@/components/operacion-portal/OperacionPwa";
import { robotsMeta } from "@/lib/seo";

interface Busqueda {
  t?: string;
  redirect?: string;
}

export const Route = createFileRoute("/operacion/acceso")({
  // El token de invitación llega por ?t=; se valida su forma y no se refleja en ningún otro lugar.
  validateSearch: (s: Record<string, unknown>): Busqueda => ({
    ...(typeof s["t"] === "string" && /^[0-9a-f]{64}$/.test(s["t"]) ? { t: s["t"] } : {}),
    ...(typeof s["redirect"] === "string" ? { redirect: s["redirect"] } : {}),
  }),
  head: () => ({
    meta: [{ title: "Acceso — Operación en Vivo" }, ...robotsMeta(false, false)],
  }),
  component: AccesoPage,
});

function AccesoPage() {
  const { t, redirect } = Route.useSearch();
  return (
    <main className="flex min-h-screen items-center justify-center bg-background p-4">
      <OperacionPwa />
      <AccesoForm token={t} redirect={redirect} />
    </main>
  );
}
